import ArrowTriangleheadSwapBbold from './ArrowTriangleheadSwapBbold';

export default ArrowTriangleheadSwapBbold;
